import { render, staticRenderFns } from "./SectionPrehomeCreateBannerComponent.vue?vue&type=template&id=0f9776ac"
import script from "./SectionPrehomeCreateBannerComponent.vue?vue&type=script&lang=js"
export * from "./SectionPrehomeCreateBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports